var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#081327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98775 4.01685L8.97168 5.02449L6.49406 7.50212L5.51012 6.51818L7.98775 4.01685Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48143 5.51052L10.4654 6.51816L6.49406 10.4895L5.51012 9.50554L9.48143 5.51052Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00054 7.00423L5.98448 8.01188L5.00054 8.99582L4.0166 8.01188L5.00054 7.00423Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9752 7.00423L11.9592 8.01188L7.98787 11.9832L7.00394 10.9993L10.9752 7.00423Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#36F7D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.ab4d45c4f5130db3d407f3906685e6cc.svg";
export { ForwardRef as ReactComponent };